// extracted by mini-css-extract-plugin
export default {"betOnAll":"n_o","betOnAllLabel":"n_p"};